import * as React from "react";
type Props = {
  className?: string,
};
function SvgOpenBoxNew({ className }: Props) {
  return (
    <svg
      viewBox="0 0 63 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-OpenBoxNew"
      className={className}
    >
      <g clipPath="url(#clip0_1529_5508)">
        <path
          d="M55.009 15.4126H8.06445V49.2766H55.009V15.4126Z"
          stroke="#283A70"
          strokeMiterlimit={10}
        />
        <path
          d="M19.9931 11.4472L13.9561 0.723633H1.13477L7.96228 15.1375L19.95 11.3459H43.0054L55.0362 15.3546L61.8637 0.940709H49.0424L43.106 11.4472"
          stroke="#283A70"
          strokeMiterlimit={10}
        />
        <path
          d="M23.5451 40.116C23.7962 38.1085 24.7663 36.2623 26.2735 34.924C27.7807 33.5857 29.7214 32.8472 31.731 32.8472C33.7406 32.8472 35.681 33.5857 37.1882 34.924C38.6954 36.2623 39.6655 38.1085 39.9166 40.116H47.3624C47.2762 39.4792 46.0255 30.5211 38.2206 26.8598C34.9831 25.3879 31.3478 25.0566 27.9004 25.9192C25.4212 26.5732 23.1344 27.8178 21.2332 29.5482C19.332 31.2785 17.872 33.4437 16.9762 35.8613C16.4729 37.227 16.1775 38.6614 16.0996 40.116H23.5451Z"
          stroke="#283A70"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_1529_5508">
          <rect width={63} height={50} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgOpenBoxNew;
